<template>
  <v-card class="px-5 py-3 rounded-lg elevation-0 mb-4" outlined>
    <template v-if="!selectedQuotation">
      <div class="d-flex justify-space-between align-center mb-2">
        <div class="d-flex align-center">
          <v-icon color="primary" class="mr-2"
            >mdi-file-document-outline</v-icon
          >
          <div class="text-h6 font-weight-bold">Quotation Details</div>
        </div>
      </div>
      <div class="text-center py-8 grey--text">
        <v-icon size="48" color="grey lighten-2" class="mb-2">
          mdi-information-outline
        </v-icon>
        <div>No quotation information available</div>
      </div>
    </template>
    <template v-else>
      <div class="d-flex justify-space-between align-center mb-2">
        <div class="d-flex align-center">
          <v-icon color="primary" class="mr-2"
            >mdi-file-document-outline</v-icon
          >
          <div class="text-h6 font-weight-bold">Quotation Details</div>
        </div>
        <Barcode
          v-if="selectedQuotation.barcode"
          small
          :barcode="selectedQuotation.barcode"
          :id="Number(selectedQuotation.id)"
          :route="'quotation.detail'"
        ></Barcode>
      </div>

      <!-- Title -->
      <div class="mb-2">
        <div class="grey--text text-caption-1">Title</div>
        <div class="text-body-1 font-weight-medium">
          {{ selectedQuotation.title || "—" }}
        </div>
      </div>
      <div class="d-flex align-top">
        <!-- Site Location Block -->
        <v-card
          flat
          outlined
          class="pa-3 rounded-lg elevation-0 left-border-orange w-50 mr-3"
        >
          <div class="text-subtitle-1 orange--text font-weight-medium mb-2">
            Site Location
          </div>

          <div>
            <div class="d-flex align-center mb-1">
              <v-icon small class="mr-1">mdi-map-marker</v-icon>
              <span>{{ selectedQuotation.site_location || "" }}</span>
            </div>

            <a
              v-if="selectedQuotation.site_location"
              :href="
                'https://www.google.com/maps/search/?api=1&query=' +
                encodeURIComponent(selectedQuotation.site_location)
              "
              target="_blank"
              class="blue--text text-caption-1 mt-1 d-block"
              style="text-decoration: none"
            >
              <v-icon x-small class="mr-1" color="blue">mdi-open-in-new</v-icon>
              View on Google Maps
            </a>
          </div>
        </v-card>
        <v-card
          flat
          outlined
          class="pa-3 rounded-lg elevation-0 left-border-green w-50"
        >
          <div class="text-subtitle-1 green--text font-weight-medium mb-2">
            Contact Person
          </div>

          <template
            v-if="
              selectedQuotation.contact_person &&
              selectedQuotation.contact_person.display_name &&
              selectedQuotation.contact_person.display_name !== '-'
            "
          >
            <!-- Name -->
            <div class="d-flex align-center mb-1">
              <v-icon small class="mr-1">mdi-account</v-icon>
              <span>
                {{ selectedQuotation.contact_person.display_name }}
              </span>
            </div>

            <!-- Email -->
            <div
              v-if="selectedQuotation.contact_person.primary_email"
              class="d-flex align-center mb-1 cursor-pointer hover-effect"
            >
              <v-icon small class="mr-1">mdi-email</v-icon>
              <span>{{ selectedQuotation.contact_person.primary_email }}</span>
            </div>

            <!-- Phone -->
            <div
              v-if="selectedQuotation.contact_person.primary_phone"
              class="d-flex align-center cursor-pointer hover-effect"
            >
              <v-icon small class="mr-1">mdi-phone</v-icon>
              <span>{{ selectedQuotation.contact_person.primary_phone }}</span>
            </div>
          </template>

          <em v-else class="text-muted">No contact person</em>
        </v-card>
      </div>
    </template>
  </v-card>
</template>
<script>
import CommonMixin from "@/core/plugins/common-mixin";
import Barcode from "@/view/pages/partials/Barcode.vue";

export default {
  name: "claim-detail",
  title: "Claim",
  mixins: [CommonMixin],
  data() {
    return {
      visitLoading: false,
    };
  },
  props: {
    selectedQuotation: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  components: {
    Barcode,
  },
};
</script>
